import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { useDisclosure, useHover } from '@mantine/hooks';
import { useEffect } from 'react';
import { ITagPill, Tag } from './Tags.styles';
import { useDelayedHover } from './TagWithDelete.hooks';

export function TagWithDelete(props: TagWithDeleteProps) {
  const {
    name,
    showDelete,
    onDeleteIconClick,
    tooltip = null,
    onTagHoverChange,
    ...tagDivProps
  } = props;
  // Todo: Maybe package this all into one "useProperlyDelayedHover" wrapper???
  const { hovered, ref } = useHover();
  const [opened, handlers] = useDisclosure(false);
  const { openDropdown, closeDropdown } = useDelayedHover({
    open() {
      handlers.open();
      if (onTagHoverChange) onTagHoverChange(true);
    },
    close() {
      handlers.close();
      if (onTagHoverChange) onTagHoverChange(false);
    },
    openDelay: 400,
    closeDelay: 400,
  });
  useEffect(() => {
    if (hovered) {
      openDropdown();
    } else {
      closeDropdown();
    }
  }, [hovered]);

  // Either the tag controls hover or it's controlled externally
  let showDeleteIcon = opened;
  if (typeof showDelete === 'boolean') showDeleteIcon = showDelete;
  return (
    <Tag ref={ref} {...tagDivProps}>
      {name}

      {showDeleteIcon && (
        <BActionIcon
          variant="transparent"
          ml={10}
          size={20}
          icon="delete"
          onClick={onDeleteIconClick}
          color={tagDivProps.deleted ? 'ered.4' : 'neutral.7'}
        />
      )}
      {tooltip}
    </Tag>
  );
}
export interface TagWithDeleteProps
  extends ITagPill,
    Omit<React.HTMLProps<HTMLDivElement>, 'ref' | 'as' | 'children'> {
  name: string;
  showDelete?: boolean;
  onDeleteIconClick?: React.MouseEventHandler<HTMLButtonElement>;
  tooltip?: JSX.Element;
  onTagHoverChange?: (value: boolean) => any;
}
